    import React, { useEffect } from "react";
    import { Link, useNavigate } from "react-router-dom";
    import { all_routes } from "../../router/all_routes";

    import { useDispatch, useSelector } from "react-redux";
    import { useForm } from "react-hook-form";
    import { yupResolver } from "@hookform/resolvers/yup";
    import * as Yup from "yup";
    import { forgotPassword } from "../../../core/data/redux/adminAuthSlice";
    import Toasts from "../../../core/common/toast";
    import type { DatePickerProps } from "antd";
    import { DatePicker, TimePicker } from "antd";
    import dayjs from "dayjs";


    import '../login/employeeLogin.css'

    const schema = Yup.object().shape({
    username: Yup.string().required("Username is required"),
    dob: Yup.string().required("Date of birth is required"),
    });

    const ForgotPassword = () => {
    const routes = all_routes;
    const navigation = useNavigate();
    const dispatch = useDispatch();
    const employeeAuthState = useSelector(
        (state: any) => state.adminAuthState
    );

    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });


    const onChange: DatePickerProps["onChange"] = (date) => {
      if (date) {
        const formatted = dayjs(date).format("YYYY-MM-DD");
        setValue("dob", formatted);
      } else {
        setValue("dob", "");
      }
    };

    const onSubmit = (data: any) => {
        dispatch(forgotPassword(data));
    };

    useEffect(() => {
        if (
        employeeAuthState.loading === "fulfilled" &&
        employeeAuthState.action === "forgot-password"
        ) {
        navigation(routes.adminVerifyOtp);
        }
    }, [employeeAuthState.loading]);

    return (
      <div className="">
        <Toasts
          show={employeeAuthState.loading === "rejected"}
          message={employeeAuthState.error}
          title={"Login Failed"}
          type={"danger"}
        />
        <Toasts
          show={employeeAuthState.loading === "fulfilled"}
          message={employeeAuthState?.user?.data?.message}
          title={"Success"}
          type={"success"}
        />
        <div className="hero">
          <div className="sub-hero">
            <div className="img-logo">
              <img src="/assets/img/login/logo.png" alt="logoimage" />
            </div>
            <p className="text-white fs-3  fw-bold sub-title text-center">
              Forget Password
            </p>
            {/* Form */}
            <div className="">
              <form
                action=""
                onSubmit={handleSubmit(onSubmit)}
                className="form-container"
              >
                <div className="form-group">
                  <label className="">Username</label>
                  <input
                    type="text"
                    defaultValue=""
                    className="form-input"
                    placeholder="username"
                    maxLength={8}
                    {...register("username")}
                  />
                  {errors.username && (
                    <small className="text-white align-items-left">
                      {errors.username.message}
                    </small>
                  )}
                </div>

                <div className="form-group">
                  <label className="">Date of Birth</label>

                  <DatePicker
                    onChange={onChange}
                    className="form-input custom-date-picker"
                    placeholder="DD-MM-YYYY"
                    format="DD-MM-YYYY"
                  />
                  {errors.dob && (
                    <small className="text-white align-items-left">
                      {errors.dob.message}
                    </small>
                  )}
                </div>

                <button
                  type="submit"
                  className="submit-btn"
                  disabled={employeeAuthState.loading === "pending"}
                >
                  {employeeAuthState.loading === "pending" ? "Submitting..." : "Submit"}
                </button>

                <div className="sign-in">
                  <p>
                    Change Mind ?
                    <Link to={all_routes.adminLogin} className="reset-password">
                      Sign in Here
                    </Link>
                  </p>
                </div>
                <p className="terms-text">
                  By clicking on Sign In, you agree to our Terms of service and
                  Privacy Policy
                </p>
              </form>
            </div>
          </div>
          <div className="right-img">
            <div className="ladies-img">
              <img src="/assets/img/login/ladies.png" alt="" />
            </div>
            <div className="metro-img">
              <img src="/assets/img/login/metroo.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    );
    };

    export default ForgotPassword;
